import React from "react";
import { observer } from "mobx-react-lite";
import { store } from "../../store";
import { AvatarTooltip } from "../AvatarTooltip";
import { offset } from "@floating-ui/react";
import "./PreviewMode.css";

export const PreviewMode = observer(function PreviewMode() {
  if (!store.isPreview) return null;

  return (
    <div className="preview-container">
      <div className="preview-mode-banner">
        <span className="preview-mode-text">Preview mode</span>
        <AvatarTooltip
          content="Close preview mode"
          tooltipProps={{
            placement: "right",
            offset: 24,
          }}
        >
          <div className="preview-mode-close-button-container">
            <button
              className="preview-mode-close-button"
              onClick={() => {
                store.previewManager.closePreview();
              }}
              aria-label="Close preview"
            >
              ×
            </button>
          </div>
        </AvatarTooltip>
      </div>
    </div>
  );
});
